var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.valueModel,
        expression: "valueModel"
      }
    ],
    ref: "input",
    staticClass: "form-control",
    attrs: { type: "text" },
    domProps: { value: _vm.valueModel },
    on: {
      blur: function($event) {
        return _vm.tryParseValue()
      },
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.valueModel = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }